<template>
    <div class="table-paginator-container">
        <square-button :icon="`fas ${cardsDisplayMode ? 'fa-table-list' : 'fa-table-cells-large'}`"
                       :tooltip-text="cardsDisplayMode ? t_show_as_list : t_show_as_grid"
                       color="secondary"
                       flat
                       @click="$emit('card-button-click')" />

        <slot name="prepend" />

        <v-pagination
            :length="numPages"
            :next-aria-label="t_next"
            :previous-aria-label="t_previous"
            :total-visible="9"
            :value="currentPage"
            style="flex-grow: 1"
            @input="onPageChange($event)"
        />

        <div style="display: flex; align-items: center; margin-inline-start: auto; gap: 8px;">
            {{ currentPageReport }}

            <v-select-custom
                :items="itemsPerPageDropdownItems"
                :value="numRowsPerPage"
                aria-label="number of rows per page"
                inline
                @input="$emit('update:numRowsPerPage', $event)">
                <template #item="{item}">
                    <template v-if="item.value < 100">&nbsp;</template>
                    {{ item.text }}
                </template>
                <template #selection="{item}">
                    <template v-if="item.value < 100">&nbsp;</template>
                    {{ item.text }}
                </template>
            </v-select-custom>
            {{ t_entries + ' ' + t_per_page }}
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

import SquareButton from '../squareButton.vue';

export default defineComponent({
    components: {
        SquareButton
    },
    props: {
        numRowsPerPage: {
            type: Number,
            required: true
        },
        renderedRows: {
            type: Number,
            required: true
        },
        cardsDisplayMode: {
            type: Boolean,
            required: true
        },
        firstDisplayedEntryIndex: {
            type: Number,
            required: true
        },
        menuOnTop: Boolean
    },
    data() {
        return {
            itemsPerPageDropdownItems: [
                { value: 10, text: '10' },
                { value: 25, text: '25' },
                { value: 50, text: '50' },
                { value: 100, text: '100' }
            ],

            t_show_as_list: Lang.langGet('Show as list'),
            t_show_as_grid: Lang.langGet('Show as grid'),
            t_previous: Lang.langGet('Previous'),
            t_next: Lang.langGet('Next'),
            t_entries: Lang.langGet('entries'),
            t_per_page: Lang.langGet('per page')
        };
    },
    computed: {
        currentPageReport() {
            return `[ ${this.renderedRows} ` + this.t_entries + `]`;
        },
        currentPage() {
            const tempPageNum = this.firstDisplayedEntryIndex / this.numRowsPerPage;

            if (Number.isInteger(tempPageNum)) {
                return tempPageNum + 1;
            } else {
                return Math.ceil(tempPageNum);
            }
        },
        numPages() {
            const tempNumPages = this.renderedRows / this.numRowsPerPage;
            return Math.ceil(tempNumPages);
        }
    },
    methods: {
        onPageChange(pageNum) {
            this.$emit('update:firstDisplayedEntryIndex', (pageNum - 1) * this.numRowsPerPage);
        }
    }
});
</script>
